module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0016.e1b8d15b.jpg";